import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useHierarchyTags } from "shared/composables/hierarchyTags";
import { useCriticalPath, usePlanConfig } from "shared/composables/planner";
import { useProjectDurationSettings } from "shared/composables/projectDurationSettings";
import { useTrackEvent } from "shared/composables/tracking";
import CriticalPathModal from "shared/views/critical_path/components/CriticalPathModal.vue";
import {
  useDeltaTextWithBackgroundClass,
  useFormattedDelta,
} from "shared/views/critical_path/composables";
import { calculateDelta } from "shared/views/critical_path/criticalPath";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlannerDeltaBadge',
  props: {
    origin: {}
  },
  setup(__props: any) {



const { t } = useI18n();

const isCriticalPathModalOpen = ref(false);

const { criticalPath } = useCriticalPath();
const { planConfig } = usePlanConfig();
const { projectDurationSettings } = useProjectDurationSettings();
const { hierarchyTags } = useHierarchyTags();
const trackEvent = useTrackEvent();

const delta = computed(() => {
  if (
    !criticalPath.value ||
    !planConfig.value ||
    !projectDurationSettings.value ||
    hierarchyTags.value.length === 0
  ) {
    return null;
  }
  return calculateDelta(
    criticalPath.value,
    planConfig.value,
    hierarchyTags.value,
    projectDurationSettings.value,
  );
});

const deltaClass = useDeltaTextWithBackgroundClass(delta);
const formattedDelta = useFormattedDelta(delta);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (delta.value !== null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "planner-delta-badge",
          class: _normalizeClass(["font-bold text-sm hover:underline flex items-center gap-1 cursor-pointer rounded-full px-3 py-1 self-center h-min", _unref(deltaClass)]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
      isCriticalPathModalOpen.value = true;
      _unref(trackEvent)('planner_delta_click', { origin: _ctx.origin });
    })
        }, [
          _createTextVNode(_toDisplayString(_unref(formattedDelta)) + " " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")) + " ", 1),
          _createVNode(_unref(MagnifyingGlassIcon), { class: "w-4 h-4" })
        ], 2))
      : _createCommentVNode("", true),
    (isCriticalPathModalOpen.value)
      ? (_openBlock(), _createBlock(CriticalPathModal, {
          key: 1,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isCriticalPathModalOpen.value = false)),
          origin: _ctx.origin
        }, null, 8, ["origin"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})